import CollectPointsPage from "./CollectPointsPage";

export default CollectPointsPage;
